export const VIDEO_TYPES_ENUM = {
    NONE: 'none',
    YOUTUBE: 'youtube',
    VIMEO: 'vimeo',
    VIDEO_CIPHER: 'videoCipher',
    ZOOM_PENPENCLIVDO: 'zoom penpencilvdo',
    SECURE_VIDEO: 'penpencilvdo',
    ANT_MEDIA: 'antMedia',
    JW_PLAYER: 'jwPlayer',
    AWS_VIDEO: 'awsVideo',
    TENCENT_VIDEO: 'tencentVideo',
    ZOOM: 'zoom',
    MP4: 'mp4',
};
export const VIDEO_TYPES = [
    {
        value: 'none',
        viewValue: 'None',
    },
    {
        value: 'youtube',
        viewValue: 'Youtube',
    },
    {
        value: 'vimeo',
        viewValue: 'Vimeo',
    },
    {
        value: 'videoCipher',
        viewValue: 'Video Cipher',
    },
    {
        value: 'zoom penpencilvdo',
        viewValue: 'Zoom Penpencil Video',
    },
    {
        value: 'penpencilvdo',
        viewValue: 'Secure Video',
    },
    {
        value: 'antMedia',
        viewValue: 'Ant Media',
    },
    {
        value: 'jwPlayer',
        viewValue: 'JW Player',
    },
    {
        value: 'awsVideo',
        viewValue: ' AWS Video',
    },
    {
        value: 'zoom',
        viewValue: 'Zoom',
    },
    {
        value: 'mp4',
        viewValue: 'MP4',
    },
];

export enum VideoEntryPoint {
    ADMIN_BATCHES_PREVIEW_VIDEOS = 'ADMIN_BATCHES_PREVIEW_VIDEOS',
}
